import { render } from "./NoDisponible.vue?vue&type=template&id=55fb6154&scoped=true"
import script from "./NoDisponible.vue?vue&type=script&lang=js"
export * from "./NoDisponible.vue?vue&type=script&lang=js"

import "./NoDisponible.vue?vue&type=style&index=0&id=55fb6154&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fb6154"]])

export default __exports__